import type { Dispatch } from 'react';
import type { Action, Match, MatchEvent, MatchTeamStatus } from '../types';
import { STATUS, teamById } from '../mock/data';

// Apply a manual status-pill edit. Always changes the team's match status; when
// `logNote` is set (ops edits — routine vol/staff pre-queue flips don't need an
// audit trail) it also drops a match note recording the before→after
// transition. EC is single-team with no match timeline, so EC pills keep
// dispatching SET_MATCH_STATUS directly and never reach here.
export function applyStatusEdit(
  dispatch: Dispatch<Action>,
  match: Match,
  side: 'red' | 'blue',
  to: MatchTeamStatus,
  event: MatchEvent,
  logNote: boolean,
): void {
  const from = side === 'red' ? match.redS : match.blueS;
  dispatch({ type: 'SET_MATCH_STATUS', event, matchId: match.id, side, status: to });
  if (logNote && from !== to) {
    const team = side === 'red' ? match.red : match.blue;
    dispatch({
      type: 'APPEND_MATCH_NOTE',
      matchId: match.id,
      body: `${teamById(team).short} status: ${STATUS[from].label} → ${STATUS[to].label}`,
    });
  }
}
